import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useIsOverlayOpen } from "../screens/reader/hooks/hookstate/useIsOverlayOpen";
import { useSlideInMenu } from "../components/slideInMenu/hooks/useSlideInMenu";
import { useIsSidebarOpen } from "./useIsSidebarOpen";
import { useIsSmallBreakpoint } from "../utils/useBreakpoints";
import { readerComponentsStore } from "../hookstate/readerComponentStore";
import { isReaderRoute } from "../utils/isReaderRoute";

export function useDisableBodyScroll() {
  const { isOverlayOpen } = useIsOverlayOpen();
  const { openMenu } = useSlideInMenu();
  const { isSidebarOpen } = useIsSidebarOpen();
  const isSmallBreakpoint = useIsSmallBreakpoint();
  const location = useLocation();

  // Close reader overlay on any pathname change (navigating away or switching modes)
  useEffect(() => {
    if (!isOverlayOpen) return;

    readerComponentsStore.isOverlayOpen.set(false);

    // Restore scroll if leaving reader
    if (!isReaderRoute(location.pathname)) {
      document.documentElement.style.overflowX = "hidden";
      document.documentElement.style.overflowY = "auto";
      document.documentElement.style.scrollbarGutter = "";
    }
  }, [location.pathname]);

  useEffect(() => {
    const shouldDisableScroll =
      isOverlayOpen || openMenu || (isSmallBreakpoint && isSidebarOpen);

    if (shouldDisableScroll) {
      // Check if scrollbar is currently showing
      const hasScrollbar =
        document.documentElement.scrollHeight >
        document.documentElement.clientHeight;

      document.documentElement.style.overflowX = "hidden";
      document.documentElement.style.overflowY = "hidden";

      // Only set scrollbar-gutter if scrollbar was showing
      if (hasScrollbar && !isSmallBreakpoint) {
        document.documentElement.style.scrollbarGutter = "stable";
      }
    } else {
      document.documentElement.style.overflowX = "hidden";
      document.documentElement.style.overflowY = "auto";
      document.documentElement.style.scrollbarGutter = "";
    }

    return () => {
      document.documentElement.style.overflowX = "hidden";
      document.documentElement.style.overflowY = "auto";
      document.documentElement.style.scrollbarGutter = "";
    };
  }, [isOverlayOpen, openMenu, isSidebarOpen, isSmallBreakpoint]);
}
